import RedirectURLFormDialog from './RedirectURLFormDialog';

export default RedirectURLFormDialog;
